import { render } from "./AdminShell.vue?vue&type=template&id=5a5c6580&scoped=true"
import script from "./AdminShell.vue?vue&type=script&lang=js"
export * from "./AdminShell.vue?vue&type=script&lang=js"

import "./AdminShell.vue?vue&type=style&index=0&id=5a5c6580&scoped=true&lang=css"
import "./AdminShell.vue?vue&type=style&index=1&id=5a5c6580&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5c6580"]])

export default __exports__